import { THEME } from '@belong/themes';
import { ThemeProvider } from 'styled-components';
import BaseModal from './BaseModal';
import { Button } from '../../actions/Button';

const Modal: typeof BaseModal = ({ ...props }) => (
  <ThemeProvider theme={THEME}>
    <BaseModal ButtonComponent={Button} {...props} />
  </ThemeProvider>
);

Modal.displayName = 'Modal';
export default Modal;
